import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=72711ffd"
import script from "./AlertError.js?vue&type=script&lang=js&external"
export * from "./AlertError.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports